import React, { Component } from "react";
import PropTypes from "prop-types";

export default class Watermark extends Component {
  render() {
    let id =
      this.props.idealStudio_document_id ||
      (window.idealStudio_editor_params
        ? window.idealStudio_editor_params.idealStudio_resource_id
        : null);
    let parent = null;
    try {
      parent = this.whichDomain(window.parent.location.href, id);
    } catch (e) {}
    let platform = this.props.idealStudio_platform
      ? this.props.idealStudio_platform + "/idealStudio_documents/" + id
      : window.location.href;
    let current = this.whichDomain(platform, id) || "";
    let educa = (current || "").match(/educainternet/) ? " educa" : "";
    return parent ? null : (
      <a target="_blank" href={current}>
        <div className={"embedWaterMark" + educa} />
      </a>
    );
  }
  whichDomain(windowUrl, id) {
    let allowedDomains = ["localhost:3000", "localhost:8080", "https://www.ideaelearning.net/"];
    let allowedDomainsHref = [
      "" + id,
      "https://educainternet.es/idealStudio_documents/" + id,
      "http://localhost:3000/idealStudio_documents/" + id,
      "",
      "https://www.ideaelearning.net/",
    ];
    let allowedDomain = false;
    allowedDomains.map((domain, i) => {
      if (windowUrl.indexOf(domain) > -1) {
        let match = windowUrl.match(/idealStudio_documents\/(\d+)/);
        /* if(match && match[1]) {
                    allowedDomain = allowedDomainsHref[i](match[1]);
                } else {*/
        allowedDomain = allowedDomainsHref[i];
        // }
      }
    });
    return allowedDomain;
  }
}

Watermark.propTypes = {
  /**
   * IdealStudio Document id
   */
  idealStudio_document_id: PropTypes.any,
  /**
   * Platform where excursion is hosted
   */
  idealStudio_platform: PropTypes.any,
};
